import api from "./api";
import { toast } from "sonner";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

function triggerBlobDownload(blob, filename) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename || "download";
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 4000);
}

// For authenticated API endpoints (e.g. /api/requests/{id}/photos/zip)
export async function downloadAuthed(path, filename) {
    try {
        const res = await api.get(path, { responseType: "blob" });
        const blob = new Blob([res.data], { type: res.headers?.["content-type"] || "application/octet-stream" });
        triggerBlobDownload(blob, filename);
    } catch (e) {
        toast.error(e?.response?.data?.detail || "Download mislukt");
    }
}

// For static URLs (e.g. /api/uploads/xxx.jpg).
//
// Opens the file in a new browser tab via a synthetic <a target="_blank"> click.
// Synthetic anchor clicks triggered from user-initiated event handlers are
// treated as user gestures and are NOT blocked by popup blockers (unlike
// window.open). We never navigate the current tab so the project view always
// stays available — the user can simply close the new tab to come back.
//
// In the new tab the browser shows the file inline (video player, image, PDF
// viewer) and the user can save it with Cmd/Ctrl+S or right-click → "Save as".
// If `filename` is provided, the backend will issue a presigned URL with a
// Content-Disposition: attachment header so the browser saves it directly with
// that filename — useful for 4K video downloads.
export function downloadStatic(urlOrPath, filename) {
    if (!urlOrPath) {
        toast.error("Geen bestand beschikbaar");
        return;
    }
    let path = urlOrPath;
    // If the asset path is an internal /api/uploads/... and a friendly filename is provided,
    // append ?dl=<filename> so backend forces an attachment download with that name.
    if (filename && !urlOrPath.startsWith("http") && urlOrPath.includes("/api/uploads/")) {
        const sep = urlOrPath.includes("?") ? "&" : "?";
        path = `${urlOrPath}${sep}dl=${encodeURIComponent(filename)}`;
    }
    const fullUrl = path.startsWith("http") ? path : `${BACKEND}${path}`;
    const a = document.createElement("a");
    a.href = fullUrl;
    a.target = "_blank";
    a.rel = "noopener noreferrer";
    document.body.appendChild(a);
    a.click();
    a.remove();
}
